import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AddressDetails.metadata.json5';
import styles from './AddressDetails.module.scss'

function AddressDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { yourHomeVM, updateSubmissionVM, showErrors, findInvalidComponent, onValidate, submissionVM, steps, resetAllCodes } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const ADDRESS_COMPONENT = 'AddressDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(ADDRESS_COMPONENT);
    const primaryAddress = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.primaryAddress')
    const accountHolderAddress = _.get(submissionVM, 'baseData.accountHolder.primaryAddress'); // DE18299
    const resetPaths = [
        'primaryAddress.addressLine1',
        'primaryAddress.city',
        'primaryAddress.postalCode',
    ];

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        if (findInvalidComponent) {
            findInvalidComponent(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        const pageSubmitted = steps.some(step => step.path === '/propertydetails' && step.submitted)

        if ((!pageSubmitted &&  primaryAddress === undefined)) {
            _.set(submissionVM.value, 'lobData.homeowners_tfpa.coverables.yourHome', {})
            _.set(submissionVM.value, 'lobData.homeowners_tfpa.coverables.yourHome.primaryAddress', {})
        }

        const policyAddress = submissionVM.baseData.policyAddress.value;
        const txCode = viewModelService.productMetadata.get('pc').types.getTypelist('State').getCode('TX');
        
        if( primaryAddress === undefined) {
        _.set(yourHomeVM, 'primaryAddress.addressLine1', policyAddress.addressLine1)
        _.set(yourHomeVM, 'primaryAddress.addressLine2', policyAddress.addressLine2)
        _.set(yourHomeVM, 'primaryAddress.addressLine3', policyAddress.addressLine3)
        _.set(yourHomeVM, 'primaryAddress.city', policyAddress.city)
        _.set(yourHomeVM, 'primaryAddress.country', policyAddress.country)
        _.set(yourHomeVM, 'primaryAddress.county', '')
        _.set(yourHomeVM, 'primaryAddress.state', txCode.code)
        _.set(yourHomeVM, 'primaryAddress.postalCode', policyAddress.postalCode)
        }
    }, [])

    const writeValue = useCallback(
        (value, path) => {

            if (resetPaths.includes(path) && (value !== undefined || value === "")) {
                resetAllCodes();
            }

            _.set(yourHomeVM, path, value);
            updateSubmissionVM(yourHomeVM);
        },
        [resetAllCodes, resetPaths, updateSubmissionVM, yourHomeVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            // showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={yourHomeVM}
            overrideProps={overrideProps}
            showErrors={showErrors}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            // onModelChange={updateYourHome}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

// AddressDetails.propTypes = wizardProps;
export default AddressDetails;
